module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.parse())
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-732118b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/TemplateColumnComponent.vue
// module id = 1323
// module chunks = 2